import axios from 'axios';
import { isValid } from 'src/services/auth';
import showToast from '../toastyService';

const proxyUrl = window.globalConfig.PROXY_URL;

export const fileService = {
  getFile: async (url, path, filename) => {
    const URL_FILESERVER = url; /*localStorage.getItem('fileServer');*/

    try {
      const response = await axios.get(`${proxyUrl}/file-database`, {
        headers: {
          path,
          url: URL_FILESERVER,
          route: '/file',
          'Content-type': 'application/json',
          filename: filename.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        },
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao baixar o arquivo');
    }
  },

  renameFile: async (path, oldFilename, newFilename) => {
    const URL_FILESERVER = localStorage.getItem('fileServer');

    try {
      await axios.patch(
        `${proxyUrl}/file-database`,
        {},
        {
          headers: {
            path,
            url: URL_FILESERVER,
            route: '/file',
            'old-filename': oldFilename
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
            'new-filename': newFilename
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          },
        }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao renomear o arquivo');
    }
  },

  listRecursiveFiles: async () => {
    const URL_FILESERVER = localStorage.getItem('fileServer');

    try {
      const response = await axios.get(`${proxyUrl}/file-database`, {
        headers: {
          url: URL_FILESERVER,
          route: '/recursive-files',
        },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao buscar os arquivos');
    }
  },

  listFiles: async (url, path) => {
    const URL_FILESERVER = url; /*localStorage.getItem('fileServer');*/

    try {
      const response = await axios.get(`${proxyUrl}/file-database`, {
        headers: {
          path,
          url: URL_FILESERVER,
          route: '/files',
        },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao buscar os arquivos');
    }
  },

  uploadFiles: async (url, path, files) => {
    const URL_FILESERVER = url; /*localStorage.getItem('fileServer')*/ // ou onde estiver definido

    const data = new FormData();

    files.forEach((file) => {
      data.append(
        'files',
        file,
        file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      );
    });

    if (!isValid(url)) {
      showToast('error', 'Url não especificada.');
      return;
    }

    try {
      await axios.post(`${proxyUrl}/file-database`, data, {
        headers: {
          path,
          url: URL_FILESERVER,
          route: '/files',
        },
        maxBodyLength: Infinity,
      });
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao enviar os arquivos');
    }
  },

  deleteFiles: async (url, path, files) => {
    const URL_FILESERVER = url; /*localStorage.getItem('fileServer');*/

    try {
      await axios.delete(`${proxyUrl}/file-database`, {
        headers: {
          path,
          url: URL_FILESERVER,
          route: '/files',
          'Content-type': 'application/json',
        },
        data: files,
      });
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao excluir os arquivos');
    }
  },

  createFolder: async (path, foldername) => {
    const URL_FILESERVER = localStorage.getItem('fileServer');

    try {
      await axios.post(
        `${proxyUrl}/file-database`,
        {},
        {
          headers: {
            foldername,
            path,
            route: '/folder',
            url: URL_FILESERVER,
          },
        }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu um erro ao criar o diretório');
    }
  },

  getAllowedFileTypes: async () => {
    const URL_FILESERVER = localStorage.getItem('fileServer');

    try {
      const response = await axios.get(`${proxyUrl}/file-database`, {
        headers: {
          route: '/allowed-types',
          url: URL_FILESERVER,
        },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw new Error('Ocorreu ao buscar os tipos de arquivo permitidos');
    }
  },
};
